import { html, ref } from "@microsoft/fast-element";
import { Table } from "./table";
function tableTemplateFunction() {
    return html `
    <slot name="start"></slot>
    <table
      part="table"
      role="table"
      aria-label="${(x) => (x.sortable ? "table with sort" : "table")}"
      ?sortable="${(x) => x.sortable}"
    >
      <thead role="rowgroup">
        <tr ${ref("tableHeadRef")} role="row">
          <slot name="table-head-row"></slot>
        </tr>
      </thead>
      <tbody ${ref("tableBodyRef")} role="rowgroup">
        <slot name="table-body"></slot>
      </tbody>
    </table>
    <slot name="end"></slot>
  `;
}
export const template = tableTemplateFunction();
//# sourceMappingURL=table.template.js.map